export default __webpack_public_path__ + "static/media/close.c6f711e5.svg";